export default __webpack_public_path__ + "static/media/13847.risk-investment-team-board.photo.1c52c6e4.jpg";